const apiBaseUrl = "https://api-photo.jeonghyeon.net";

export function resolveApiBaseUrl(): string {
  return apiBaseUrl;
}
